export enum AgreementTypeEnum {
  Permanent = 1,
  FixedTerm = 2,
  Trial = 3,
  Temporary = 10,
}
